import AccountForm from "./AccountFormContainer";
import AccountScreen from "./AccountScreen";

export default {
  AccountForm,
  AccountScreen
};
